import { render, staticRenderFns } from "./WorkPermit.vue?vue&type=template&id=1a288820"
import script from "./WorkPermit.vue?vue&type=script&lang=js"
export * from "./WorkPermit.vue?vue&type=script&lang=js"
import style0 from "./WorkPermit.vue?vue&type=style&index=0&id=1a288820&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports